// extracted by mini-css-extract-plugin
export default {"badgeWrapper":"_p-z","badgeLink":"aq-z","category":"bq-z"};